import { localAtom } from '../../lib/recoil/persist';

export const profileCompletionFlowStepIndex = localAtom<number>({
  key: 'profileCompletionFlowStepIndex',
  default: 0,
});
